import useId from '../utils/useId';
import * as React from 'react';
export const copilotSvg = React.forwardRef(function copilotSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  const id_5 = baseId + '_5';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.843 6.695a2.461 2.461 0 0 0-2.328-1.664H18.34a2.46 2.46 0 0 0-2.422 2.026l-1.225 6.815.477-1.599a2.46 2.46 0 0 1 2.358-1.757h4.428l1.895 1.104 1.827-1.104h-.768a2.461 2.461 0 0 1-2.329-1.664l-.738-2.157Z',
      fill: `url(#bi_copilot__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.428 25.294a2.46 2.46 0 0 0 2.332 1.675h2.036a2.46 2.46 0 0 0 2.46-2.448l.036-6.423-.474 1.617a2.461 2.461 0 0 1-2.361 1.77H10l-1.625-1.248-1.758 1.247h.759a2.46 2.46 0 0 1 2.332 1.675l.72 2.135Z',
      fill: `url(#bi_copilot__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.164 5.031H9.936c-2.637 0-4.22 3.45-5.274 6.9-1.25 4.088-2.884 9.555 1.846 9.555h4.143a2.463 2.463 0 0 0 2.367-1.78c.686-2.376 1.927-6.66 2.899-9.906.484-1.62.888-3.01 1.508-3.876a2.087 2.087 0 0 1 1.74-.893Z',
      fill: `url(#bi_copilot__c_${id_2})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.164 5.031H9.936c-2.637 0-4.22 3.45-5.274 6.9-1.25 4.088-2.884 9.555 1.846 9.555h4.143a2.463 2.463 0 0 0 2.367-1.78c.686-2.376 1.927-6.66 2.899-9.906.484-1.62.888-3.01 1.508-3.876a2.087 2.087 0 0 1 1.74-.893Z',
      fill: `url(#bi_copilot__d_${id_3})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.834 26.969h9.229c2.636 0 4.218-3.45 5.273-6.902 1.25-4.088 2.885-9.555-1.846-9.555h-4.143a2.464 2.464 0 0 0-2.367 1.78c-.685 2.377-1.927 6.66-2.899 9.907-.484 1.62-.888 3.011-1.508 3.877a2.087 2.087 0 0 1-1.739.893Z',
      fill: `url(#bi_copilot__e_${id_4})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.834 26.969h9.229c2.636 0 4.218-3.45 5.273-6.902 1.25-4.088 2.885-9.555-1.846-9.555h-4.143a2.464 2.464 0 0 0-2.367 1.78c-.685 2.377-1.927 6.66-2.899 9.907-.484 1.62-.888 3.011-1.508 3.877a2.087 2.087 0 0 1-1.739.893Z',
      fill: `url(#bi_copilot__f_${id_5})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_copilot__a_${id_0}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform:
            'matrix(-6.22536 -7.21477 -6.72137 6.05151 24.079 13.93)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.096,
          stopColor: '#00AEFF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.773,
          stopColor: '#2253CE',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#0736C4',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_copilot__b_${id_1}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform:
            'matrix(5.58154 6.68999 6.58888 -5.46051 8.554 21.019)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFB657',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.634,
          stopColor: '#FF5F3D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.923,
          stopColor: '#C02B3C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_copilot__c_${id_2}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform:
            'matrix(-.83608 -14.5799 82.7113 -4.64953 9.707 21.48)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.03,
          stopColor: '#FFC800',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.31,
          stopColor: '#98BD42',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.49,
          stopColor: '#52B471',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.844,
          stopColor: '#0D91E1',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_copilot__e_${id_4}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform:
            'matrix(-7.29056 20.6412 -24.8126 -9.10997 25.964 8.9)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.066,
          stopColor: '#8C48FF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.5,
          stopColor: '#F2598A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.896,
          stopColor: '#FFB152',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_copilot__d_${id_3}`,
          x1: 10.534,
          y1: 5.031,
          x2: 11.239,
          y2: 21.487,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#3DCBFF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.247,
          stopColor: '#0588F7',
          stopOpacity: 0,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_copilot__f_${id_5}`,
          x1: 26.693,
          y1: 9.507,
          x2: 26.684,
          y2: 13.989,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.058,
          stopColor: '#F8ADFA',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.708,
          stopColor: '#A86EDD',
          stopOpacity: 0,
        }),
      ),
    ),
  );
});
copilotSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var copilot = {
  category: 'brand',
  colorable: false,
  name: 'copilot',
  svg: copilotSvg,
};
